module.exports = "<section class=\"nearest-users\">\n    <div class=\"nearest-users__header\">\n        <h2>A proximité</h2>\n        <span class=\"nearest-users__counter\">{{ users.length }}</span>\n    </div>\n\n    <div class=\"nearest-users__list\">\n\n    </div>\n    <!--<cm-user-list [users]=\"users\"></cm-user-list>-->\n</section>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/users/nearest-user-list/nearest-user-list.component.html
// module id = ../../../../../src/app/users/nearest-user-list/nearest-user-list.component.html
// module chunks = 4